export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export const createTokenStorage = (
  key: string,
  options?: {
    encrypt?: (plain: string) => string;
    decrypt?: (cipher: string) => string;
  }
) => {
  const save = (accessToken: string, refreshToken: string) => {
    const raw = JSON.stringify({ accessToken, refreshToken });
    const serialized = options?.encrypt ? options.encrypt(raw) : raw;
    localStorage.setItem(key, serialized);
  };

  const get = (): AuthTokens | null => {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const parsedRaw = options?.decrypt ? options.decrypt(raw) : raw;
      return JSON.parse(parsedRaw) as AuthTokens;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  };

  return {
    save,
    get,
    getAccessToken: () => get()?.accessToken ?? null,
    getRefreshToken: () => get()?.refreshToken ?? null,
    setAccessToken: (accessToken: string) => {
      const current = get();
      if (!current?.refreshToken) return;
      save(accessToken, current.refreshToken);
    },
    clear: () => localStorage.removeItem(key),
  };
};
